import { ChangeDetectionStrategy, Component, input, output, signal, ViewEncapsulation } from '@angular/core';
import { ButtonGroupItem } from '@content/pricing/pricing-plans/button-group/button-group.type';
import { JoinClassNamesPipe } from '@shared/join/join-class-names.pipe';

@Component({
    selector: 'companyid-button-group',
    imports: [JoinClassNamesPipe],
    templateUrl: './button-group.component.html',
    styleUrl: './button-group.component.scss',
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ButtonGroupComponent {
    public buttonItems = input.required<ButtonGroupItem[]>();

    public activeButtonIndex = signal<number>(0);
    public selectTitle = output<string>();

    public toggle(title: string, index: number): void {
        if (index === this.activeButtonIndex()) {
            return;
        }

        this.activeButtonIndex.set(index);
        this.selectTitle.emit(title);
    }
}
